import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "../store/actions";

import "./Order.scss";
import Cart from "../components/Cart/Cart";

const Order = ({ menu }) => {
    const [menuReady, setMenuReady] = useState([]);
    const [filteredMenu, setFilteredMenu] = useState([]);
    const [activeCategory, setActiveCategory] = useState("all");
    const [itemForCart, setItemForCart] = useState([]);
    let content;

    useEffect(() => {
        menu.menu.then(response => {
            setMenuReady(response.items);
            setFilteredMenu(response.items);
        });
    }, []);

    const getCategories = items => {
        let tempItems = items.map(item => {
            return item.fields.category;
        });
        let tempCategories = new Set(tempItems);
        let categories = Array.from(tempCategories);
        categories = ["all", ...categories];
        return categories;
    };

    const renderCategories = () => {
        let categories = getCategories(menuReady);
        return categories.map((category, i) => (
            <li key={i}>
                <button
                    className={`orders__menu-category${
                        activeCategory === category ? "--active" : ""
                    }`}
                    onClick={() => handleItems(category)}
                >
                    <b>{category}</b>
                </button>
            </li>
        ));
    };

    const handleItems = category => {
        let tempItems = [...menuReady];
        if (category === "all") {
            setFilteredMenu(tempItems);
        } else {
            let sortedItems = tempItems.filter(item => item.fields.category === category);
            setFilteredMenu(sortedItems);
        }
        setActiveCategory(category);
    };

    const handleToCart = item => {
        let itemIndex = itemForCart.find(itemInCart => itemInCart.id === item.id);
        if (itemIndex === undefined) {
            setItemForCart([...itemForCart, item]);
        } else {
            item.amount += 1;
            setItemForCart([...itemForCart]);
        }
    };

    if (menuReady) {
        content = (
            <>
                <h3 style={{ color: "#ffffff" }}>Order online</h3>
                <div className="container orders">
                    {/* MENU */}
                    <div className="orders__menu">
                        <div className="row">
                            <div
                                className="col-md-6"
                                style={{ height: "50px", background: "#ffffff" }}
                            >
                                <ul className="selecton brdr-b-primary mb-70">
                                    {renderCategories()}
                                </ul>
                            </div>
                        </div>
                        <div className="row">
                            <div
                                className="col-md-6 food-menu pizza"
                                style={{
                                    background: "#ffffff",
                                    height: "90vh",
                                    overflowY: "scroll"
                                }}
                            >
                                {filteredMenu.map(({ fields }, i) => {
                                    return (
                                        <div
                                            key={i}
                                            className="orders__menu-item"
                                            onClick={() => handleToCart(fields)}
                                        >
                                            <div className="s-left">
                                                <img
                                                    className="br-3 orders__menu-image"
                                                    src={fields.image.fields.file.url}
                                                    alt={fields.image.description}
                                                />
                                            </div>
                                            <div className="orders__menu-item--right">
                                                <h5 className="mb-10">
                                                    <b>{fields.name}</b>
                                                    <b className="color-primary float-right">
                                                        {fields.price} czk
                                                    </b>
                                                </h5>
                                                <p className="pr-70">
                                                    {fields.ingredients.toString()}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="col-md-6 orders__menu-cart">
                                {/* CART */}
                                <Cart
                                    itemForCart={itemForCart}
                                    setItemForCart={setItemForCart}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        content = <div>LOADING...</div>;
    }

    return (
        <section id="order" className="pos-relative">
            {content}
        </section>
    );
};

const mapStateToProps = state => ({
    menu: state.menu
});

export default connect(
    mapStateToProps,
    null
)(Order);
